import * as React from "react";

import { authorizeProducts } from "@teamprevent/common/productRestriction";

import { Customer } from "../crud/customer";

interface Props {
    customer: Customer;
    productTypes: string | string[];
}

const AuthorizeProducts: React.FunctionComponent<Props> = (props) => {
    return <>{React.Children.map(props.children, c => authorizeProducts(c, props.customer, props.productTypes))}</>;
};

export { AuthorizeProducts };
